<template>
  <div class="email-client-figure">
    <div class="email-client-figure__topbar">
      <div class="topbar-icon topbar-icon--close" />
      <div class="topbar-icon topbar-icon--minimize" />
      <div class="topbar-icon topbar-icon--maximize" />
    </div>

    <div class="email-client-figure__content">
      <div class="form-item form-item--from">
        <span class="form-item__label">From:</span>
        <span
          v-if="fromName && fromMail"
          class="form-item__value"
        >{{ fromName }} &lt;{{ fromMail }}&gt;</span>
      </div>
      <div class="note">
        <i class="ddi ddi-arrow-down bouncy" />&nbsp;This is how your address will appear to recipients.
        <a v-if="showEditButton" href="#" @click.prevent="$emit('edit-from')">Change this...</a>
      </div>
      <div class="form-item form-item--content">
        <span class="form-item__value form-item__value--placeholder first" />
        <span class="form-item__value form-item__value--placeholder second" />
        <span class="form-item__value form-item__value--placeholder third" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EmailClientFigure',

  props: {
    fromName: {
      type: String,
      default: '',
    },
    fromMail: {
      type: String,
      default: '',
    },
    showEditButton: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['edit-from'],
})
</script>


<style lang="scss" scoped>
.email-client-figure {
  overflow: hidden;
  background-color: rgba(255, 255, 255, 0.98);
  border-radius: 4px;
  border: solid 1px rgba(96, 76, 63, 0.16);

  .bouncy {
    animation-name: dd-angle-bounce;
    animation-duration: 1s;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
    animation-direction: alternate;
  }

  &__topbar {
    width: 100%;
    height: 28px;
    padding: 4px 8px;
    background-image: linear-gradient(to bottom, #e9e7e9, #d9d7d9);
    box-shadow: inset 0 -0.5px 0 0 #a09ea0;

    .topbar-icon {
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 8px;
      border-radius: 50%;

      &--close {
        background-color: #ff5f57;
        border: 1px solid #e1453f;
      }

      &--minimize {
        background-color: #ffbd2e;
        border: 1px solid #dfa023;
      }

      &--maximize {
        background-color: #29c941;
        border: 1px solid #1bac2c;
      }
    }
  }

  &__content {
    position: relative;
    padding: 20px;

    .note {
      @include lettering--p-sm--no-color;
      @include standard-box-shadow;
      position: absolute;
      left: 246px;
      top: -16px;
      background-color: var(--color-background-header);
      border-radius: 16px;
      color: var(--color-text-primary);
      border: $border--solid-light;
      padding: 4px 20px;

      a {
        color: var(--color-text-primary);
        text-decoration: underline;
        font-weight: $bold;
      }
    }

    .form-item {
      width: 100%;
      margin-bottom: 12px;

      &__label {
        margin-right: 5px;
        @include lettering--h5;
        color: var(--color-text-secondary);
      }

      &__value {
        font-size: 14px;
        letter-spacing: 0.02rem;
        font-weight: $bold;

        strong {
          margin-right: 3px;
        }

        &--placeholder {
          display: inline-block;
          height: 16px;
          vertical-align: middle;
          background-color: $silver-two;
          border-radius: 4px;
        }
      }

      &--from {
        .dd-button {
          float: right;
          margin-top: -10px;
        }
      }

      &--to {
        .form-item__value--placeholder {
          width: 278px;
        }
      }

      &--content {
        padding-top: 10px;
        margin-bottom: 0;

        .form-item__value--placeholder {
          margin-bottom: 12px;
          &.first {
            width: 350px;
          }

          &.second {
            width: 528px;
          }

          &.third {
            width: 504px;
          }
        }
      }
    }

    .signature {
      position: relative;
      min-height: 20px;

      span {
        display: inline-block;
        max-width: 80%;
      }

      &__name {
        padding: 1px 2px;
        background-color: rgba(250, 163, 62, 0.24);
        border-radius: 4px;
      }

      &__edit {
        position: absolute;
        top: -5px;
        right: 0;
      }
    }
  }

  .ddi-reply {
    font-size: 16px;
    color: $color--blue;
  }
}
</style>
